import React from 'react';

import { LoginMethod, LoginStatus } from './types';

const noop = () => undefined;
const noopPromise = async () => undefined;

export type EmailLoginHandler = (data: { email: string; captchaHeader: Record<string, string> }) => Promise<void>;
export type FacebookLoginHandler = () => Promise<void>;
export type GoogleLoginHandler = () => void;

export type LoginContextValue = {
  activeMethod: LoginMethod | null;
  onEmailLogin: EmailLoginHandler;
  onFacebookLogin: FacebookLoginHandler;
  onGoogleLogin: GoogleLoginHandler;
  status: LoginStatus;
};

export const LoginContext = React.createContext<LoginContextValue>({
  activeMethod: null,
  onEmailLogin: noopPromise,
  onFacebookLogin: noopPromise,
  onGoogleLogin: noop,
  status: 'idle',
});
